import React from 'react'
import { citiesContext } from './context';
import { CitiesProvider } from './provider';

const useCities = () => {
  const { cities, options } = React.useContext(citiesContext);
  return { cities, options };
}

export { useCities, CitiesProvider }
